import React from "react";
import { getDegree } from "../../../../graphql/queries";
import PropTypes from "prop-types";
import * as DataTypes from "../../../../constants/Data/DataTypes";
import GeneralInfo from "../../../Common/GeneralInfo";

const DegreeGeneralInfo = (props) => {
  return (
    <GeneralInfo
      modelId={props.degreeId}
      modelName={"Degree"}
      listOfProperties={[
        {
          key: 1,
          attributeName: "name",
          attributeTitle: "Name",
          description: "Degree Name",
          dataType: DataTypes.String,
        },
        {
          key: 2,
          attributeName: "order",
          attributeTitle: "Order",
          description: "Degree Appearance Order",
          dataType: DataTypes.String,
        },
        {
          key: 3,
          attributeName: "createdAt",
          attributeTitle: "Created At",
          description: "Degree Created At",
          dataType: DataTypes.DateTime,
        },
        {
          key: 4,
          attributeName: "updatedAt",
          attributeTitle: "Updated At",
          description: "Degree Updated At",
          dataType: DataTypes.DateTime,
        },
      ]}
      queryFunction={getDegree}
      queryFunctionName={"getDegree"}
    />
  );
};

DegreeGeneralInfo.propTypes = {
  degreeId: PropTypes.string.isRequired,
};

export default DegreeGeneralInfo;
